
import { Dispatch } from 'redux';
import StartupTokenApiClient from '../api/StartupTokenApiClient';
import { ReducerActions } from '../enums/ReducerActions';

const fetchStartupTokenFailed = () => ({
    type: ReducerActions.FETCH_STARTUP_TOKEN_FAILED
})

const fetchStartupTokenSucceded = (appSettings: any) => ({
    type: ReducerActions.FETCH_STARTUP_TOKEN_SUCCEEDED,
    appSettings
})

const fetchStartupToken = () => ({
    type: ReducerActions.FETCH_STARTUP_TOKEN_IN_PROGRESS
})

export default (customerId: string) => (dispatch: Dispatch<any>) => {
    return new Promise<void>(async (resolve, reject) => {
        dispatch(fetchStartupToken());
        
        try {
            const initializeStartupToken = await StartupTokenApiClient.initializeStartupToken(customerId);
            dispatch(fetchStartupTokenSucceded(initializeStartupToken));
            resolve();
        } catch {
            dispatch(fetchStartupTokenFailed());
            reject();
        }
    });
}
